import script from "./WorkingWithAttorney.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkingWithAttorney.vue?vue&type=script&setup=true&lang=js"

import "./WorkingWithAttorney.vue?vue&type=style&index=0&id=883c67c2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-883c67c2"]])

export default __exports__